import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import TaskAddIcon from "@material-ui/icons/PlaylistAdd";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import CloseIcon from "@material-ui/icons/Close";
import DesignIcon from "@material-ui/icons/AccountTree";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import EditIcon from "@material-ui/icons/Edit";
import ProcessAddIcon from "@material-ui/icons/AddCircleOutline";
import SearchIcon from "@material-ui/icons/Search";
import arraysort from "array-sort";
import React, { useEffect, useState } from "react";
import { getLoggedInUserTenantID } from "../apis/sessionUtil";
import {
  addProcess, deleteProcess, getProcesses,
  updateProcess
} from "../apis/processes";
import { SORT_DIRECTION, STATUS } from "../constants";

import "./dnd.css";
import { LightTooltip } from "./LightTooltip";
import Loading from "./Loading";
import useStyles from "./muistyles";
import "./GenericReusableComponents/table.css";
import {CreateProcessForm} from './CreateProcessForm';
import ViewIcon from '@material-ui/icons/Visibility';
import {Table} from './GenericReusableComponents/Table'
import {TButton} from "./GenericReusableComponents/HTMLWrappers"



export default function ProcessMgmt(props) {
  const headerInfo = {
    "Process Name": {
      fieldName: "name",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Business Name for a Process",
    },
    "Description": {
      fieldName: "description",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Business Description for Process",
    },
    "Priority": {
      fieldName: "priority",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Business Priority for Process",
    },

    "Status": {
      fieldName: "status",
      sortDirection: SORT_DIRECTION.DESC.value,
      toolTip: "Process Status",
    },
    "Actions": {
      toolTip: "Manage Processs",
    },
  };

  const [processes, setProcesses] = useState([]);
  const [filteredProcesses, setFilteredProcesses] = useState([]);
  const [q, setQ] = useState("");
  const [showAddEmail, setShowAddEmail] = useState(false);
  // const [showAddTaskForm,setShowAddTaskForm] = useState(false);
  // const [showDelTaskModal,setShowDelTaskModal] = useState(false);
  const [showAddTaskForm, setShowAddTaskForm] = useState(false);
  const [currentTask, setCurrentTask] = useState({});
  const [showUpdtTaskModal, setShowUpdtTaskModal] = useState(false);
  const [processesChanged, setProcessesChanged] = useState(false);
  const [selEmailTask, setSelEmailTask] = useState("");
  const [loading, setLoading] = useState(true);
  const [sortDirection, setSortDirection] = useState(SORT_DIRECTION.DESC.value);
  const [sortHeader, setSortHeader] = useState("Task Name");
  const [headerFieldMap,setHeaderFieldMap] = useState(headerInfo);
  const iconButtonStyle = {
    color: "slateblue",
    color: "black",
    // fontFamily: "Arial, Helvetica, sans-serif",
    // fontFamily: "Century",
    fontSize: "1em",
    fontWeight: "bold",
  };

  const classes = useStyles();



  useEffect(() => {
    let mounted = true;

    getProcesses().then((processes) => {
      // console.log("display Processes");
      // console.log(processes.data);
      
      if (mounted) {
        
          setProcesses(arraysort(processes.data, "name"));
          var fprocesses = [];
          processes.data.forEach((x) => fprocesses.push(x));
          setFilteredProcesses(fprocesses);
          setProcessesChanged(false);
          setLoading(false);
      }
    });
    return () => {
      // console.log("TaskMgmt is unmounted");
      mounted = false;
    };
  }, [processesChanged]);

 

  

  function toggleSortDirection() {
    if (sortDirection === SORT_DIRECTION.DESC.value) {
      setSortDirection(SORT_DIRECTION.ASC.value);
    } else {
      setSortDirection(SORT_DIRECTION.DESC.value);
    }
  }

  function filterTable(filterString) {
    console.log(filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredProcesses(processes);
      setQ("");
    } else {
      setQ(filterString);
      setFilteredProcesses(
        processes.filter((process) => {
          if (process.processName.startsWith(filterString)) return true;

          if (process.description.startsWith(filterString)) return true;

          if (process.priority.startsWith(filterString)) return true;

          if (process.status.startsWith(filterString)) return true;

          console.log("no match ");
          console.dir(process);
        })
      );
    }
  }

  function setProcessesChangedTrigger(bool) {
    console.log("setprocessesChanged " + bool);
    setProcessesChanged(bool);
  }

  function handleAddTask() {
    console.log("handleAddTask");
    setShowAddTaskForm(true);
  }


  function view(e, processItem){
    const taskId = processItem.processId
    const tenantId = getLoggedInUserTenantID();

    // var url = `${process.env.REACT_APP_API_PREFIX}/task/getTasksByTenantId/${tenantId}`;
    props.onProcessIdChange(processItem.processId, processItem.name)
    props.setTabIndex(2)
  }






  //temporarily duplicating the code. reuse later
  function getStatusStyle(status) {
    var statusStyle = "status";
    switch (status) {
      case "INACTIVE":
        statusStyle = statusStyle + " statusInactive";
        break;
      case "DISABLED":
        statusStyle = statusStyle + " statusDisabled";
        break;

      default:
        statusStyle = statusStyle + " statusActive";
    }
    return statusStyle;
  }

  function updateProcessesState(process) {
    let lprocesses = [...filteredProcesses];
    let i = lprocesses.findIndex((t) => t.processId === process.processId);
    lprocesses[i] = { ...process };
    setFilteredProcesses(lprocesses);
    setProcesses(lprocesses);
  }

  function handleClickOnEdit(process) {
    process.makeRowEditable = true;
    process.update = true;
    setCurrentTask({ ...process });
  }
  function update(process) {
    let lprocess = { ...currentTask };
    lprocess.makeRowEditable = false;
    process.update = false;
    updateProcessesState(lprocess);
    updateProcess(lprocess)
      .then(res => { return res.json()})
      .then(data => {
        console.log("Update Task successful")
        console.log(JSON.stringify(data));
        setCurrentTask({});
        setProcessesChanged(true);
        setLoading(true);
      })
      .catch((err) => {
        console.error(err.message);
        throw err;
      });

    
  }

  function cancel(process) {
    let lprocess = { ...process };
    lprocess.makeRowEditable = false;
    process.update = false;
    updateProcessesState(lprocess);
    setCurrentTask({});
  }

 

 
  function getPriority(process) {
    if (process.makeRowEditable) {
      return (
        <Select
          name="priority"
          defaultValue={process.priority}
          onChange={(e) => {
            currentTask.priority = e.target.value;
          }}
        >
          <MenuItem value="CRITICALAL">CRITICALAL</MenuItem>
          <MenuItem value="HIGH">HIGH</MenuItem>
          <MenuItem value="MEDIUM">MEDIUM</MenuItem>
          <MenuItem value="LOW">LOW</MenuItem>
        </Select>
      );
    } else {
      return process.priority;
    }
  }


  function getProcessName(process) {
    if (process.makeRowEditable) {
      return (
        <TextField
          id="name"
          defaultValue={process.name}
          style={{ width: "150px" }}
          onChange={(e) => {
            currentTask.name = e.target.value;
          }}
        />
      );
    } else {
      return process.name;
    }
  }

  function getDescription(process) {
    if (process.makeRowEditable) {
      return (
        <TextField
          id="processDescription"
          defaultValue={process.description}
          onChange={(e) => {
            currentTask.description = e.target.value;
          }}
        />
      );
    } else {
      return process.description;
    }
  }

  function handleClickOnDelete(process) {
    process.markTobeDeleted = true;
    updateProcessesState(process);
  }

  function handleDeleteTask(process) {
    deleteProcess(process)
      .then((res) => {
        return res.json();      
      })
      .then((data) =>{
        console.log("Delete Task Succesfull");
        console.log(JSON.stringify(data));
        setProcessesChanged(true);
        setLoading(true);
      } )
      .catch((err) => {
        console.log(err.message)
        throw err;
      });
  }

  function handleCancelDelete(process) {
    process.markTobeDeleted = false;
    updateProcessesState(process);
  }

  function add(process) {
    let lprocess = { ...currentTask };
    lprocess.addnew = false;
    lprocess.makeRowEditable = false;

    let iprocess = {};
    iprocess.name = lprocess.name;
    iprocess.description = lprocess.description;
    iprocess.priority = lprocess.priority;
    iprocess.status = STATUS.ACTIVE.string;

    addProcess(iprocess)
      .then((res) => {
        console.log(res.json());
        let lprocesses = [...processes];

        let i = lprocesses.findIndex((t) => t.addnew === true);

        lprocesses[i] = { ...iprocess };
        setProcesses(lprocesses);
        setFilteredProcesses(lprocesses);
        setProcessesChanged(true);
      })
      .catch((err) => console.log(err.message));
  }

  function cancelAdd(process) {
    let lprocesses = [...processes];

    let i = lprocesses.findIndex((t) => t.addnew === true);
    lprocesses.splice(i, 1);

    setProcesses(lprocesses);
    setFilteredProcesses(lprocesses);
  }

  function goDesign(e, processItem){
    props.onProcessIdChange(processItem.processId, processItem.name)
    props.setTabIndex(1)

  }

  function getActions(process) {
    if (process.markTobeDeleted) {
      return (
        <div className='tableActions'>
          <LightTooltip title="Confirm">
            <IconButton onClick={() => handleDeleteTask(process)}>
              <DeleteIcon />
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Cancel">
            <IconButton onClick={() => handleCancelDelete(process)}>
              <CloseIcon />
            </IconButton>
          </LightTooltip>
        </div>
      );
    }

    if (process.addnew && process.makeRowEditable) {
      return (
        <div className='tableActions'>
          <LightTooltip title="Add">
            <IconButton onClick={() => add(process)}>
              <AddIcon />
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Cancel">
            <IconButton onClick={() => cancelAdd(process)}>
              <CloseIcon />
            </IconButton>
          </LightTooltip>
          </div>
      );
    }
    if (process.update && process.makeRowEditable) {
      return (
        <div className='tableActions'>
          <LightTooltip title="Update">
            <IconButton onClick={() => update(process)}>
              <DoneIcon />
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Cancel">
            <IconButton onClick={() => cancel(process)}>
              <CloseIcon />
            </IconButton>
          </LightTooltip>
          </div>
      );
    } else {
      return (
        <div className='tableActions'>
          <LightTooltip title={"Design Process"}>
        <IconButton className="toolbutton" onClick={(e)=>goDesign(e, process)}>
            <DesignIcon className ='roundButton'></DesignIcon>
          </IconButton>
          </LightTooltip>


          <LightTooltip title={"View Tasks"}>
        <IconButton className="toolbutton" onClick={(e)=>view(e, process)}>
            <ViewIcon className ='roundButton' ></ViewIcon>
          </IconButton>
          </LightTooltip>

          <LightTooltip title="Edit Process">
            <IconButton className="toolbutton" onClick={() => handleClickOnEdit(process)}>
              <EditIcon className ='roundButton' ></EditIcon>
            </IconButton>
          </LightTooltip>

          <LightTooltip title="Delete Process">
            <IconButton className="toolbutton" onClick={() => handleClickOnDelete(process)}>
              <DeleteIcon className ='roundButton' ></DeleteIcon>
            </IconButton>
          </LightTooltip>
          </div>
      );
    }
  }

  
  function sortBy(headerName, sortDirection) {
    console.log("Called sortby");
    let lprocesses = [...processes];
    let lheaderInfo = {...headerFieldMap};
    lheaderInfo[headerName].sortDirection = sortDirection; //this is the current sort direction now.
    setHeaderFieldMap(lheaderInfo);
    console.log(headerName);
    console.log(headerFieldMap[headerName].fieldName);
    arraysort(lprocesses, headerFieldMap[headerName].fieldName, {
      reverse: headerFieldMap[headerName].sortDirection,
    });
    setSortHeader(headerName);
    setProcesses(lprocesses);
    setFilteredProcesses(lprocesses);
  }

  function getHeader(headerName) {
  

    if(headerName == "Actions"){
      return(
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th>{headerName}</th>
        </LightTooltip>
      )
    }
    if (headerName != sortHeader) 
      return (
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th
            onClick={() =>
              sortBy(headerName, getFutureSortDirection(headerName))
            }
          >
            {headerName}
          </th>
        </LightTooltip>
      );
    

    //headerName is sortHeader
    if (headerFieldMap[headerName].sortDirection === SORT_DIRECTION.ASC.value) {
      return (
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th
            onClick={() =>
              sortBy( headerName , getFutureSortDirection( headerName ))
            }
          >
            <IconButton size="small" style={iconButtonStyle}>
              {headerName}
              <ArrowUpwardIcon />
            </IconButton>
          </th>
        </LightTooltip>
      );
    } else {
      return (
        <LightTooltip title={headerFieldMap[headerName].toolTip}>
          <th
            onClick={() =>
              sortBy(headerName, getFutureSortDirection(headerName))
            }
          >
            <IconButton size="small" style={iconButtonStyle}>
              {headerName}
              <ArrowDownwardIcon />
            </IconButton>
          </th>
        </LightTooltip>
      );
    }
  }

  function getFutureSortDirection(headerName) {
    if (headerFieldMap[headerName].sortDirection === SORT_DIRECTION.ASC.value) {
      return SORT_DIRECTION.DESC.value;
    } else {
      return SORT_DIRECTION.ASC.value;
    }
  }

  function getTableActions(){
    return(
      <Button
      variant="contained"
      color="primary"
      onClick={handleAddTask}
      className={classes.button }
      startIcon={<ProcessAddIcon fontSize="inherit" />}
    >
      Add Process
    </Button>


      // <TButton 
      //   toolTip="Add Process"
      //   text="Add Process"
      //   onClick={handleAddTask}
      //   startIcon={<TaskAddIcon fontSize="inherit" />}
      // />
    )
  }
  
  function getTableHeader(){

    return (

           <tr>
            {Object.keys(headerFieldMap).map((headerName) => (
              <>{getHeader(headerName)}</>
            ))}

          </tr>
    )

  }

  function getTableBody(){
    return(
      <>
           {filteredProcesses.map((process) => (
            <tr>
              <td>{getProcessName(process)}</td>
              <td>{getDescription(process)}</td>
              <td>{getPriority(process)}</td>
              <td>
                <span className={getStatusStyle(process.status)}>
                  {process.status}
                </span>
              </td>
              <td>{getActions(process)}</td>
            </tr>
          ))}
      </>
    )
  }

  // console.log("processesChanged just before render "+processesChanged);
return (
   
  <>
      <Table
        search={filterTable}
        tableActions={getTableActions()} 
        columns={getTableHeader()} 
        rows={getTableBody()}
        loading={loading}
        tbcontainerstyle={{margin:'0px',padding:'0px'}}
      />


      <CreateProcessForm
        setShow={setShowAddTaskForm}
        show={showAddTaskForm}
        setProcessesChangedTrigger={setProcessesChangedTrigger}
      />
  </>
  
     
   
  );
}
